import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { END_POINTS } from "../../Helper/Constant";
import { getApiRequest } from "../../services/getApiRequest";
import { showLoader, hideLoader } from "../loader/loaderSlice";

export const fetchEventData = createAsyncThunk(
  "event/fetchEventData",
  async ({ id, userId, lang }, { dispatch, rejectWithValue }) => {
    dispatch(showLoader());
    try {
      const params = new URLSearchParams();
      if (lang) params.set("lang", lang);
      if (userId) params.set("userId", userId);
      const query = params.toString();
      const url = `${END_POINTS.GET_EVENT_BY_ID}/${id}${query ? `?${query}` : ""}`;
      const response = await getApiRequest(url);
      return response.event;
    } catch (error) {
      // Keep the status so the page can tell a country restriction (403) apart
      return rejectWithValue({
        status: error.response?.status || null,
        message: error.response?.data?.message || error.message,
      });
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const fetchHasActiveEvents = createAsyncThunk(
  "event/fetchHasActiveEvents",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getApiRequest(END_POINTS.EVENTS_HAS_ACTIVE);
      return response?.hasActiveEvents || false;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const eventSlice = createSlice({
  name: "event",
  initialState: {
    data: null,
    status: "idle",
    error: null,
    hasActiveEvents: false,
    hasActiveEventsFromSocket: false,
  },
  reducers: {
    clearEventData: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
    setHasActiveEventsFromSocket: (state, action) => {
      state.hasActiveEvents = Boolean(action.payload);
      state.hasActiveEventsFromSocket = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchEventData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchEventData.rejected, (state, action) => {
        state.status = "failed";
        state.data = null;
        state.error = action.payload;
      })
      .addCase(fetchHasActiveEvents.fulfilled, (state, action) => {
        if (!state.hasActiveEventsFromSocket) {
          state.hasActiveEvents = Boolean(action.payload);
        }
      });
  },
});

export const { clearEventData, setHasActiveEventsFromSocket } = eventSlice.actions;
export default eventSlice.reducer;
